(function ($) {
	class W4D_Student_Form {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('#student_form');
			this.$submitBtn = this.$form.find('button[type="submit"]');
		}

		bindEvents() {
			W4D_FrontendHelper.startButtonCountdownUntilEnabled(this.$submitBtn, 9);

			this.$form.validate({
				submitHandler: (form) => {
					if (!W4D_FrontendHelper.checkHoneypot(this.$form)) {
						return;
					}

					this.handleSubmit(form);
				},
			});
		}

		handleSubmit(form) {
			const fd = new FormData(form);

			fd.append('action', 'w4d_handle_student_form_submit');
			fd.append('nonce', w4d_frontend_ajax.nonce);

			$(form)
				.find('input[type="file"]')
				.each(function () {
					const files = window.W4D_FileStore.get(this) || [];
					files.forEach((file) => {
						fd.append('student-card__upload[]', file, file.name);
					});
				});

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				type: 'POST',
				data: fd,
				processData: false,
				contentType: false,
				success: (response) => {
					if (response.success) {
						this.$form.empty().html(response.data.success_html);
						W4D_Toast.showToast('success', response.data.message);
						this.$form[0].reset();
					} else {
						const errorMessage = response && response.data ? response.data.message : 'Došlo je do pogreške.';
						W4D_Toast.showToast('error', errorMessage);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do pogreške. Pokušajte ponovno.');
				},
			});
		}
	}

	$(document).ready(function () {
		new W4D_Student_Form();
	});
})(jQuery);
